module.exports = __webpack_public_path__ + "img/xueyuan.5da644ee.png";